import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AgencyDetailsFacade } from '@shared/feature/agency-details';
import { Observable, catchError, map, of, take } from 'rxjs';

export const DownloadClientGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
  const agencyDetailsFacade = inject(AgencyDetailsFacade);
  const router = inject(Router);

  return agencyDetailsFacade.getAgencyDetails().pipe(
    take(1),
    map((x) => {
      if (state.url === '/downloads' && !x.canDownloadClient) {
        router.navigate(['Error', '403']);

        return false;
      }

      return true;
    }),
    catchError(() => {
      router.navigate(['Error', 'InternalServer']);

      return of(false);
    })
  );
};
